import type { Icon } from "@globalgiving/icons"
import { colors } from "@globalgiving/styles"
import { FC } from "react"

export const DashboardIcon: FC<Icon> = ({
  width = "20",
  height = "20",
  currentColor = colors.secondary.navy.DEFAULT,
  ...props
}) => (
  <svg fill="none" height={height} viewBox="0 0 20 20" width={width} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      clipRule="evenodd"
      d="M11.92 3.91999V6.47999H16.08V3.91999H11.92ZM3.92005 3.91999V9.67999H8.08005V3.91999H3.92005ZM11.92 10.32V16.08H16.08V10.32H11.92ZM3.92005 13.52V16.08H8.08005V13.52H3.92005ZM10.8 7.59999H17.2V2.79999H10.8V7.59999ZM2.80005 10.8H9.20005V2.79999H2.80005V10.8ZM10.8 17.2H17.2V9.19999H10.8V17.2ZM2.80005 17.2H9.20005V12.4H2.80005V17.2Z"
      fill={currentColor}
      fillRule="evenodd"
    />
  </svg>
)
